module.exports = __webpack_public_path__ + "img/earth-dark-small.7d9e6572.svg";